import { Link } from "react-router-dom";
import { Phone, ExternalLink, HeartHandshake, Instagram, Facebook, Youtube, Music2 } from "lucide-react";

const COL1 = [
  { to: "/que-es-pasta-base", label: "¿Qué es la Pasta Base?" },
  { to: "/efectos", label: "Efectos" },
  { to: "/test-dependencia", label: "Test de Dependencia" },
  { to: "/tratamientos", label: "Tratamientos" },
  { to: "/blog", label: "Blog" },
  { to: "/preguntas-frecuentes", label: "Preguntas Frecuentes" },
  { to: "/nosotros", label: "Quiénes Somos" },
];

const COL2 = [
  { href: "https://sinadicciones.org/centros-de-rehabilitacion-drogas-chile", label: "Buscar Centros de Rehabilitación" },
  { href: "https://sinadicciones.org/profesionales", label: "Buscar Profesionales" },
  { href: "https://sinadicciones.org/talleres", label: "Talleres Terapéuticos" },
  { href: "https://sinadicciones.org/comparar", label: "Comparar Centros" },
  { href: "https://sinadicciones.org/zona-cero", label: "TerapeutAI — Asistente IA" },
];

const SOCIALS = [
  {
    name: "Instagram",
    href: "https://www.instagram.com/sinadicciones_org/",
    Icon: Instagram,
    testid: "social-instagram",
  },
  {
    name: "Facebook",
    href: "https://web.facebook.com/profile.php?id=61585407995202",
    Icon: Facebook,
    testid: "social-facebook",
  },
  {
    name: "TikTok",
    href: "https://www.tiktok.com/@sinadicciones.org",
    Icon: Music2,
    testid: "social-tiktok",
  },
  {
    name: "YouTube",
    href: "https://www.youtube.com/@sinadicciones_org",
    Icon: Youtube,
    testid: "social-youtube",
  },
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-800 bg-slate-950">
      <div className="mx-auto max-w-7xl px-5 py-14 lg:px-8">
        <div className="grid gap-10 lg:grid-cols-4">
          {/* Brand */}
          <div className="lg:col-span-1">
            <Link to="/" className="flex items-center gap-2 text-slate-50">
              <span className="grid h-8 w-8 place-items-center rounded-md bg-emerald-500/15 ring-1 ring-emerald-500/40">
                <span className="h-2 w-2 rounded-full bg-emerald-400" />
              </span>
              <span className="text-base font-bold tracking-tight">
                pasta-base<span className="text-emerald-400">.cl</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              Información verificada sobre la pasta base en Chile y acceso a
              ayuda profesional real a través de la red SinAdicciones.org.
            </p>

            <div
              data-testid="social-links"
              className="mt-6 flex items-center gap-2"
            >
              {SOCIALS.map(({ name, href, Icon, testid }) => (
                <a
                  key={name}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label={name}
                  title={name}
                  data-testid={testid}
                  className="group inline-flex h-9 w-9 items-center justify-center rounded-full border border-slate-800 bg-slate-900/60 text-slate-400 transition hover:border-emerald-500/40 hover:bg-emerald-500/10 hover:text-emerald-300"
                >
                  <Icon className="h-4 w-4" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
              pasta-base.cl
            </h3>
            <ul className="space-y-2.5 text-sm">
              {COL1.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.to.replace("/", "")}`}
                    className="text-slate-300 transition hover:text-emerald-400"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-slate-400">
              SinAdicciones.org
            </h3>
            <ul className="space-y-2.5 text-sm">
              {COL2.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1.5 text-slate-300 transition hover:text-emerald-400"
                  >
                    {l.label}
                    <ExternalLink className="h-3 w-3 opacity-60" />
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="mb-4 text-xs font-bold uppercase tracking-[0.18em] text-red-400">
              Ayuda Urgente
            </h3>
            <div className="space-y-3">
              <a
                href="tel:1412"
                data-testid="footer-senda-phone"
                className="flex items-start gap-3 rounded-lg border border-red-500/20 bg-red-500/5 p-3 transition hover:bg-red-500/10"
              >
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-red-400" />
                <div>
                  <div className="text-sm font-semibold text-slate-50">
                    Fono Drogas SENDA: 1412
                  </div>
                  <div className="text-xs text-slate-400">24/7 · gratuito · confidencial</div>
                </div>
              </a>
              <a
                href="tel:6003607777"
                className="flex items-start gap-3 rounded-lg border border-slate-800 bg-slate-900/50 p-3 transition hover:bg-slate-900"
              >
                <HeartHandshake className="mt-0.5 h-4 w-4 shrink-0 text-cyan-400" />
                <div>
                  <div className="text-sm font-semibold text-slate-50">
                    Salud Responde: 600 360 7777
                  </div>
                  <div className="text-xs text-slate-400">Si estás en crisis, llama ahora</div>
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-slate-800 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
          <p>
            pasta-base.cl es parte de la red{" "}
            <a
              href="https://sinadicciones.org"
              target="_blank"
              rel="noopener noreferrer"
              className="text-emerald-400 hover:underline"
            >
              SinAdicciones.org
            </a>
          </p>
          <p>© {new Date().getFullYear()} pasta-base.cl — Política de Privacidad</p>
        </div>
      </div>
    </footer>
  );
}
